export const editCDInfoFromList = (cdList, editingId, cdInfo) => {
    const currentCDList = [...cdList];
    currentCDList.splice(parseInt(editingId), 1, cdInfo);
    return currentCDList;
};
